exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7cc81c3a] .el-input-number .el-input__inner{text-align:left}", ""]);

// exports
